import {
  COOKIE_DOMAIN,
  isNH,
  PASSPORT_URL,
  PATH_AUTH_CALLBACK,
  PATH_LOGIN,
  PATH_PRIVACY_POLICY,
  STORE_KEY_REDIRECT,
  TokenKey,
  NHTokenKey,
  UserNameKey,
} from "@/constants/config"
import docCookies from "./cookies"

var _user = null

const Env = {
  ignoreCheck() {
    let hash = window.location.hash
    const ignorePaths = [PATH_LOGIN, PATH_AUTH_CALLBACK, PATH_PRIVACY_POLICY]
    const ignore = ignorePaths.some((path) => new RegExp(path).test(hash))
    return ignore
  },
  checkAndLogin() {
    if (this.ignoreCheck()) {
      return
    }
    let phoneReg = /^[1][0-9]{10}$/
    let user = this.getUser()
    if (!user[TokenKey]) {
      this.login()
    }
    // 若不是手机号则退出到登录页面
    if (!phoneReg.test(user[UserNameKey])) {
      this.login()
    }
  },
  login() {
    const hash = window.location.hash
    sessionStorage.setItem(STORE_KEY_REDIRECT, hash)
    window.location.href = isNH ? PASSPORT_URL : `#${PATH_LOGIN}?state=WayzBank`
  },
  logout(isLogin = true) {
    docCookies.removeItem(TokenKey, "/", COOKIE_DOMAIN)
    if (isLogin) {
      Env.login()
    }
  },
  readCookie() {
    const user = docCookies.parsedCookies()
    if (user && (user[TokenKey] || user[NHTokenKey])) {
      _user = user
    }
  },
  getUser: function () {
    // if (!_user) {
    this.readCookie()
    // }
    return _user || {}
  },
}
export default Env
